export default __webpack_public_path__ + "static/media/collabo.db40b6a3.svg";